import './nav.css';

export const Nav = () => {
    return (
        <div className='Nav'>
            <ul className='navOptionsList'>
                <div id='homeNavSeperator'></div>
                <div className='navOption' id='calendarNav'><a href='#calendarTarget'>Calendar</a></div>
                <div className='navOption' id='addShiftNav'><a href='#addShiftTarget'>Add Shift</a></div>
                <div className='navOption' id='caretakerHoursNav'><a href='#hoursTarget'>Caretaker Hours</a></div>
                <div className='navOption' id='clientHoursNav'><a href='#hoursBoxTargetClient'>Client Hours</a></div>
                <div className='navOption' id='aptNav'><a href='#aptCalendarTarget'>Appointments</a></div>
                <div className='navOption' id='addAppointmentNav'><a href='#addAppointmentTarget'>Add Appointment</a></div>
                { /* <div className='navOption' id='mileageInput'><a href='#mileageAdminTarget'>Mileage</a></div> */ }

            </ul>
        </div>
    )
}